import { render, staticRenderFns } from "./EmptyBoxIcon.vue?vue&type=template&id=33aa1838&"
import script from "./EmptyBoxIcon.vue?vue&type=script&lang=js&"
export * from "./EmptyBoxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports